import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../axiosComponent";
import { serviceUrls } from "../../constant";

// Utility function for common transport data preparation
const prepareTransportData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

// Transport Vehicle Driver Services
export const getDriverList = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/driver/list",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getDriver = async (entityId) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/driver",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const addDriver = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/driver",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const updateDriver = async (data) => {
  return await put({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/driver",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const deleteDriver = async (entityId) => {
  return await del({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/driver",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const updateDriverStatus = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/driver",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};
